export default {"src":"/_next/static/media/faq-icon3.510a0bd3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};